import { Amplify } from 'aws-amplify'

/**
 * Configure AWS Amplify with Cognito User Pool settings.
 * Environment variables are loaded from .env.local or .env files.
 *
 * Note: The region is derived from the userPoolId prefix (e.g., us-east-1_xxx).
 * In local auth mode (VITE_AUTH_MODE=local), Amplify configuration is skipped.
 */
export function configureAmplify() {
  // Skip Amplify configuration in local auth mode
  if (import.meta.env.VITE_AUTH_MODE === 'local') {
    console.info('Running in local auth mode - Cognito disabled')
    return
  }

  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID
  const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID

  if (!userPoolId || !userPoolClientId) {
    console.warn(
      'AWS Cognito configuration is missing. Authentication will not work. ' +
        'Set VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_CLIENT_ID in your .env.local file.'
    )
    return
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          email: true,
        },
      },
    },
  })
}
